import AddStepperNavigationComponent from "@/components/Stepper/AddStepperNavigation";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { IMPORT_CSV_FORM_HASH } from "../-constants/hash";

type Props = {
  link: {
    hash: string;
    to: string;
  };
  title: string;
  isError: boolean;
};

const AddStepperNavigation = ({ link, title, isError }: Props) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.person.importCsv.navigation",
  });

  const STEPS = [
    {
      label: t("section.step1"),
      hash: IMPORT_CSV_FORM_HASH.UPLOAD_FILE,
    },
    {
      label: t("section.step2"),
      hash: IMPORT_CSV_FORM_HASH.PREVIEW_FILE,
    },
    {
      label: t("section.step3"),
      hash: IMPORT_CSV_FORM_HASH.IMPORT_DATA,
    },
  ];

  return (
    <AddStepperNavigationComponent
      title={title}
      baseLink={link.to}
      currentHash={link.hash}
      isError={isError}
      steps={STEPS}
    />
  );
};

export default AddStepperNavigation;
